import { inject } from '@angular/core'
import { CanActivateFn } from '@angular/router'
import { NavController } from '@ionic/angular'
import { GlobalStore } from 'src/app/store/global.store'

export const levelsGuard: CanActivateFn = () => {
  if (
    typeof window !== 'undefined' &&
    (window as { __PW_BYPASS_LEVELS_GUARD__?: boolean }).__PW_BYPASS_LEVELS_GUARD__
  ) {
    return true
  }

  const globalStore = inject(GlobalStore)
  const userLevel = globalStore.appState.userLevel.level()
  const navController = inject(NavController)

  if (userLevel === 0) {
    return true
  } else {
    navController.navigateForward('solventa/request-loan-module', {
      animated: true,
      replaceUrl: true,
    })
    return false
  }
}
